import { render, staticRenderFns } from "./FamilyLogin.vue?vue&type=template&id=33165b66&scoped=true&"
import script from "./FamilyLogin.vue?vue&type=script&lang=js&"
export * from "./FamilyLogin.vue?vue&type=script&lang=js&"
import style0 from "./FamilyLogin.vue?vue&type=style&index=0&id=33165b66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33165b66",
  null
  
)

export default component.exports